import Vue from 'vue';
import { CUSTOM_FIELD_TYPES as CF_TYPES } from '@/views/projects-list/sections/constants';
import { formatDateUTC } from '@/utils/helpers/date';

// The API advertises 4 decimal places (maxDecimalPoints), but customfieldvalues_decimal is
// decimal(10,2), so 3 and 4 truncate on save without an error. Keep this list at 0-2 until the
// column is widened. The same list is in teamwork-lightspeed src/module/customfield/constants.ts.
export const DECIMAL_PLACE_OPTIONS = [0, 1, 2];

// The magnitude customfieldvalues_decimal can hold: 8 integer digits and 2 decimal places.
export const MAX_DECIMAL_VALUE = 99999999.99;

export const DEFAULT_DECIMAL_PLACES = 2;

export const formatFieldsForSubmit = (customFields) => {
  if (!customFields) {
    return [];
  }
  return customFields.map((customField) => ({
    customFieldId: customField.customfieldId,
    type: customField.type,
    value:
      customField.type === 'date' && customField.value
        ? formatDateUTC(customField.value, 'YYYY-MM-DD')
        : customField.value,
    urlTextToDisplay: customField.urlTextToDisplay,
  }));
};

// Validates the input of various types of custom field
export const validateFields = (customFields) => {
  const errors = [];
  customFields.forEach((customField) => {
    if (customField.type === 'number-integer') {
      if (customField.value && !/^[0-9 -]+$/.test(customField.value)) {
        errors.push(`${Vue.t('Custom Field [_s] must be a whole number', customField.name)}`);
      }
      return;
    }
    if (customField.type === 'number-decimal' || customField.type === 'financial') {
      const value = String(customField.value).trim();
      if (customField.value && !/^-?(?:\d+(?:\.\d+)?|\.\d+)$/.test(value)) {
        errors.push(`${Vue.t('Custom Field [_s] must be a number', customField.name)}`);
      } else if (customField.value && Math.abs(Number(value)) > MAX_DECIMAL_VALUE) {
        errors.push(`${Vue.t('Custom Field [_s] is too large', customField.name)}`);
      }
    }
  });
  return errors;
};

export const isMultipleOption = (type) => [CF_TYPES.DROPDOWN, CF_TYPES.STATUS].includes(type);

export const hasDecimalPlaces = (type) => [CF_TYPES.DECIMAL, CF_TYPES.FINANCIAL].includes(type);

export function getCustomFieldIconByType(customFieldType) {
  return (
    {
      checkbox: 'check-square-light',
      date: 'calendar-light',
      dropdown: 'circle-chevron-down-light',
      'number-integer': 'hashtag-light',
      'number-decimal': 'hashtag-light',
      financial: 'circle-dollar-light',
      status: 'exclamation-triangle',
      'text-short': 'text',
      url: 'link-light',
    }[customFieldType] || 'text'
  );
}

export const checkEmptyRequiredCustomFields = (customFields = [], requiredCustomFieldIds = []) => {
  if (!customFields.length || !requiredCustomFieldIds.length) {
    return false;
  }
  const requiredCustomFields = customFields.filter((field) => requiredCustomFieldIds.includes(field.customfieldId));
  return requiredCustomFields.some((field) => {
    // Checkbox field can have false as its value
    return typeof field.value !== 'boolean' && !field.value;
  });
};
